export enum PdpTypeEnum {
  ACCESSORY = 'ACCESSORY',
  IFU = 'IFU',
  FAQ = 'FAQ',
  PRODUCT = 'PRODUCT'
}
